import React from "react";
const Index = React.lazy(() => import("./index"));
const MemberShipFreezingDetails = React.lazy(() =>
  import("./MemberShipFreezingDateDetails")
);

export const memberShipFreezingDateRoutes = [
  {
    path: "/admin/membershipfreezingRequest",
    name: "All Membership Freezing Requests",
    element: <Index />,
  },
  {
    path: "/admin/membershipfreezingRequest/:id",
    name: "Membership Freezing Request Detail",
    element: <MemberShipFreezingDetails />,
  },
];
